import {
  AfterViewInit,
  Component,
  inject,
  isDevMode,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SaleEvent, Upgrade } from '@core/models';
import {
  AvailabilityService,
  CartService,
  DvmService,
  TutorialService,
} from '@core/services';
import { AdobeDataLayerService } from '@core/services/adobe-data-layer-service.service';
import { CartRestorerService } from '@core/services/cart-restorer.service';
import { Subscription } from 'rxjs';
import { UpgradesService } from './viewer/topbar/upgrades/upgrades.service';

@Component({
  selector: 'app-select-seat',
  templateUrl: './select-seat.component.html',
  styleUrl: './select-seat.component.scss',
})
export class SelectSeatComponent implements OnInit, AfterViewInit, OnDestroy {
  // SERVICES
  private adobeDataLayerService = inject(AdobeDataLayerService);
  private availabilityService: AvailabilityService =
    inject(AvailabilityService);
  private upgradesService: UpgradesService = inject(UpgradesService);
  private tutorialService = inject(TutorialService);
  private cartService = inject(CartService);
  private dvmService = inject(DvmService);
  private cartRestorerService = inject(CartRestorerService);
  private activatedRoute = inject(ActivatedRoute);

  // DATA
  private event: SaleEvent = inject(ActivatedRoute).snapshot.data['event'];
  public availability: string[];
  public showTabsOnMobile = true;

  // DEBUGGER
  protected debugger: boolean =
    inject(ActivatedRoute).snapshot.queryParams['debugger'] === 'true' ||
    isDevMode();

  // html placement for popovers
  @ViewChild('dynamicPopover', { read: ViewContainerRef })
  public popoverPlacement: ViewContainerRef;
  public subscriptions: Subscription[] = [];

  // LIFE CYCLE
  ngOnInit(): void {
    this.initComponent();
  }

  ngAfterViewInit(): void {
    // set popover placement once the view has loaded
    this.dvmService.popoverPlacement = this.popoverPlacement;
  }

  // METHODS
  public toggleTabsOnMobile() {
    this.showTabsOnMobile = !this.showTabsOnMobile;
  }

  private initComponent(): void {
    if (this.dvmService.viewerService.isInitialized()) {
      this.dvmService.viewerService.unselectAll();
      this.cartService.resetCart();
    }
    this.tutorialService.openTutorialForNewUser(this.event);
    this.adobeDataLayerService.setEventId(this.event.pvEventId);
    this.adobeDataLayerService.setEvent(this.event);
    // Check if we have an event response
    if (this.event) {
      // Asignamos los valores de min y max tickets al servicio de Availability
      this.availabilityService.minSeatsLimit = this.event.minTickets as number;
      this.availabilityService.maxSeatsLimit = this.event.maxTickets as number;

      // Asignamos upgrades
      this.upgradesService.upgrades = this.event.upgrades as Upgrade[];

      // LLamamos al servicio de Availability para obtener la disponibilidad de la sección.
      // Esto nos permite conesguir datos que necesitamos en los componentes child como el price range
      const subscription = this.availabilityService
        .getSectionAvailability(this.event.pvEventId)
        .subscribe({
          next: (availability: string[]) => {
            this.availability = availability;
            this.dvmService.viewerService.waitInitialize().subscribe(() => {
              const restoreCart =
                this.activatedRoute.snapshot.queryParamMap.get(
                  'restore-cart'
                ) === '1';
              if (restoreCart) {
                this.cartRestorerService.restoreSelectedSeats();
              }
            });
          },
          error: error => {
            this.availability = [];
            console.error('Error getting availability', error);
          },
        });
      this.subscriptions.push(subscription);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
